// Shared by PdfPage, the edit toolbars and PdfViewerHost. Kept apart from
// PdfViewerHost so importing these doesn't pull the viewer into the main chunk
// (the viewer is lazy-loaded).

/**
 * Subject the Edit text tool stamps on its white-out rectangles. The Drive
 * BFF's POST /api/pdf/flatten finds them by it and redacts what's under them
 * (PdfToolEndpoints.CoverSubject) — keep the two in step.
 */
export const EDIT_COVER_SUBJECT = "fg:edit-cover";

export type PdfMode = "view" | "edit";

/** Edit tools that stay "pressed" while the user places / draws something. */
export type EditTool = "none" | "redact" | "table" | "edit-text" | "add-text" | "shape" | "sign" | "note" | "space";

export type ShapeKind = "Rectangle" | "Circle" | "Line" | "Arrow";

/** Annotation modes PdfViewerHost.setTool accepts. */
export type DrawTool = "None" | "Redact" | "Field" | "FreeText" | "Note" | "Space" | "HandWrittenSignature" | ShapeKind;

/** A box on one page (1-based), in the viewer's page pixels at 100 % zoom — the units annotations use. */
export interface PageRect {
    page: number;
    left: number;
    top: number;
    width: number;
    height: number;
}

/** The last text selection on a page: its bounds, words and line height (0 when unknown). */
export interface TextSelectionInfo extends PageRect {
    text: string;
    lineHeight: number;
}

export type ViewerChangeKind = "annotationAdd" | "annotationRemove" | "annotationChange" | "signature" | "formField" | "history";

/** Something the user changed in the document. */
export interface ViewerChange {
    kind: ViewerChangeKind;
    annotationId?: string;
    /** The annotation type ("FreeText", "Rectangle", "Stamp", …). */
    annotationType?: string;
    subject?: string;
    /** Where an added annotation landed. */
    rect?: PageRect;
}

export interface FreeTextStyle {
    fontFamily: string;
    fontSize: number;
    fontColor: string;
    bold: boolean;
    italic: boolean;
    align: "left" | "center" | "right";
    /** Line height as a multiple of the font size. */
    lineSpacing: number;
}
